import React from "react";
import { Outlet } from "react-router-dom";
// import NavBar from "../components/NavBar";
import { Box} from "@mui/material";
import Footer from "../components/Footer";
import WhatsUp from "../components/WhatsUp";
import NavBar from './../components/NavBar';

const UserLayout = () => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "white",
      }}
    >
      <NavBar />

      <main
       

       
      >
        <Outlet />
      </main>
       <WhatsUp /> 

      <Footer />
    </Box>
  );
};

export default UserLayout;
